import { Stack } from '@festina-life/ui/structure'

import { useRequiredBranchOperationsContext } from '../../workspace/operationsContext'
import { ShadowedTemplateLinks } from '../shadowedTemplateLinks/ShadowedTemplateLinks'

export const BranchShadowedOperationsPanel = () => {
  const { branchShadowedTemplateOperations, branchKey } =
    useRequiredBranchOperationsContext()

  return (
    <Stack gap="condensed" padding="condensed" className="flex-col">
      <ShadowedTemplateLinks
        conflicts={branchShadowedTemplateOperations}
        branch={branchKey}
      />
    </Stack>
  )
}
